class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

// 2-9-25 new script added

customElements.define('main-search', MainSearch);
if (!customElements.get("grid-color-swatches")) {
  class CustomGridColorSwatches extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Your custom JavaScript logic for grid color swatches goes here
      const radios = this.querySelectorAll(".color-swatch__radio");
      radios.forEach((radio) => {
        radio.addEventListener("change", this.onChange.bind(this, radio));
      });
    }

    disconnectedCallback() {
      const radios = this.querySelectorAll(".color-swatch__radio");
      radios.forEach((radio) => {
        radio.removeEventListener("change", this.onChange.bind(this, radio));
      });
    }

    onChange(radio) {
      // Handle change event logic here
      const variantId = radio.getAttribute("data-variant-id");
      const productHandle = radio.getAttribute("data-product-handle");
      const imageElement = radio.getAttribute("data-image-element");
      let shopUrl = window.shopUrl;
      let productUrl = shopUrl + "/products/" + productHandle+'?variant='+variantId+'&section_id=product-grid-color-swatch-image';
      fetch(`${productUrl}`)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        
        const productImages = responseHTML.querySelector('#shopify-section-product-grid-color-swatch-image').innerHTML;
        if (productImages.trim() !== '') {
          const targetElement = document.getElementById(imageElement);
          if (targetElement) { 
            const primaryImage = targetElement.querySelector('.product-grid-primary__image');
            primaryImage.remove();
            targetElement.insertAdjacentHTML('afterbegin', productImages);
          }
        }
      });
    }
  }

  customElements.define("grid-color-swatches", CustomGridColorSwatches);
}
  document.addEventListener('DOMContentLoaded', function () {
    function setupSelectRedirect(selectId) {
      const el = document.getElementById(selectId);
      if (el) {
        el.addEventListener('change', function () {
          const url = this.value;
          if (url) {
            window.location.href = url;
          }
        });

        const currentURL = window.location.href;
        for (let i = 0; i < el.options.length; i++) {
          const option = el.options[i];
          if (option.value && currentURL.includes(option.value)) {
            el.selectedIndex = i;

            const label = document.querySelector('label[for="' + selectId + '"]');
            if (label && option.text.trim() !== "") {
              label.innerHTML += " <strong>" + option.text + "</strong>";
            }

            break;
          }
        }
      }
    }

    setupSelectRedirect('frame-shape-filter');
    setupSelectRedirect('frame-width-filter');
    setupSelectRedirect('colour-filter');
    setupSelectRedirect('face-shape-filter');

    const sortSelect = document.getElementById('sort-by-filter');
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const currentSortBy = params.get('sort_by');
    if (currentSortBy) {
      for (let option of sortSelect.options) {
        if (option.value === currentSortBy) {
          option.setAttribute('selected', 'selected');
        } else {
          option.removeAttribute('selected');
        }
      }
    }
    sortSelect.addEventListener('change', function () {
      const sortBy = this.value;
      params.set('sort_by', sortBy);
      const newUrl = `${url.pathname}?${params.toString()}`;
      window.location.href = newUrl;
    });
    
  });
